import { useContext, useEffect, useState } from "react";
import VerifiedTickIcon from "../../../component/icons/verified-tick";
import Link3Icon from "../../../component/icons/link-3";
import PlusIcon from "../../../component/icons/plus";
import { GlobalContext } from "../../../context/Context";
import Style from "./style.module.css";
import CompanySettingAddUpdate from "./modal";
import { Alert, Snackbar } from "@mui/material";
import MyAccount from "./myaccount";
import SettingsNotifications from "./notifications";
import LoginPassword from "./login-password";
import SettingsOperations from "./operations";
import Tooltip from "../../../component/ui/tooltip";
import Device from "./devices/device";

const Setting = () => {
  let { state } = useContext(GlobalContext);
  const [tab, setTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setShowModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const onTabChange = (value) => {
    setTab(value);
  };

  // read user data from context or localStorage
  const userData =
    state?.user || JSON.parse(localStorage.getItem("user") || "{}");

  // Helper initials
  const getInitials = (name = "") => {
    if (!name) return "U";
    const parts = name.trim().split(" ").filter(Boolean);
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  return (
    <>
      <div className={` ${Style.mainBody} relative z-30`}  >
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_coverPhoto}>
            <img src={`${state.basePath}/cover-photo.jpg`} alt="cover" />
          </div>

          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_leftAside}>
              <div className={Style.tsd_la_head} style={{ flex: "none" }}>
                <div className={Style.profile}>
                  <span>
                    {userData?.profileImg ? (
                        <img
                          src={userData?.profileImg}
                          alt="Profile"
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.style.display = "none";
                            e.currentTarget.parentNode.innerHTML = getInitials(
                              userData?.name
                            );
                          }}
                        />
                      ) : (
                        getInitials(userData?.name)
                      )}
                    {/* <img src={`${state.basePath}/q_logo_dark.png`} alt="Logo" /> */}
                  </span>

                  <div className={Style.verifiedTick}>
                    <VerifiedTickIcon />
                  </div>
                </div>

                <h6>{userData?.name}</h6>

                <div className={Style.webUrlInput}>
                  <div className={Style.icon}>
                    <Link3Icon />
                  </div>
                  <input type="text" value={"www.legendesk.com"} />
                </div>

                {/* <div className="flex flex-col items-center gap-5 ">
                  <div className="flex gap-1 justify-start items-center">
                    <div className="relative w-12 h-12 rounded-full overflow-hidden border border-gray-300 bg-gray-100 flex items-center justify-center text-gray-600 text-2xl font-semibold">
                      {userData?.profileImg ? (
                        <img
                          src={userData?.profileImg}
                          alt="Profile"
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.currentTarget.onerror = null;
                            e.currentTarget.style.display = "none";
                            e.currentTarget.parentNode.innerHTML = getInitials(
                              userData?.name
                            );
                          }}
                        />
                      ) : (
                        getInitials(userData?.name)
                      )}
                    </div>

                    <div>
                      <h2 className="text-xl font-semibold text-gray-800 leading-tight">
                        {userData?.name}
                      </h2>
                    </div>
                  </div>

                  <div>
                  </div>
                </div> */}
              </div>

              <div className={Style.tsd_la_body}>
                <h6>
                  Quick Links
                  {/* <div
                    className={Style.teamItems_addBtn}
                    onClick={() => {
                      setShowModal(true);
                    }}
                  >
                    <PlusIcon size={"1em"} />
                  </div> */}

                   <div
                      className={Style.bpfl_action}
                      onClick={() => {
                          setShowModal(true)
                      }}
                    >
                      <Tooltip
                        content={"Add"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip>
                    </div>
                </h6>

                <div className={Style.teamItems}>
                  <span>No quick links</span>
                </div>
              </div>
            </div>

            <div className={Style.teamSpaceDashboard_body}>
              <div className={Style.dashboardTabing}>
                <div className={Style.dashboardTabing_nav}>
                  <div
                    className={`${Style.dashboardTabing_navItems} ${
                      tab === 0 ? Style.active : ""
                    }`}
                    onClick={() => {
                      onTabChange(0);
                    }}
                  >
                    <span>My Account</span>
                  </div>
                  <div
                    className={`${Style.dashboardTabing_navItems} ${
                      tab === 1 ? Style.active : ""
                    }`}
                    onClick={() => {
                      onTabChange(1);
                    }}
                  >
                    <span>Password</span>
                  </div>
                  {/* <div
                    className={`${Style.dashboardTabing_navItems} ${
                      tab === 2 ? Style.active : ""
                    }`}
                    onClick={() => {
                      onTabChange(2);
                    }}
                  >
                    <span>Notifications</span>
                  </div> */}
                  <div
                    className={`${Style.dashboardTabing_navItems} ${
                      tab === 3 ? Style.active : ""
                    }`}
                    onClick={() => {
                      onTabChange(3);
                    }}
                  >
                    <span>Operations</span>
                  </div>
                  <div
                    className={`${Style.dashboardTabing_navItems} ${
                      tab === 4 ? Style.active : ""
                    }`}
                    onClick={() => {
                      onTabChange(4);
                    }}
                  >
                    <span>Devices</span>
                  </div>
                </div>
              </div>

              {tab === 0 && <MyAccount Style={Style} />}
              {tab === 1 && <LoginPassword Style={Style} />}
              {/* {tab === 2 && <SettingsNotifications Style={Style} />} */}
              {tab === 3 && <SettingsOperations Style={Style} />}
              {tab === 4 && <Device Style={Style} />}
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <CompanySettingAddUpdate
          onClose={() => {
            setShowModal(false);
          }}
          onSubmit={onSuccess}
          onError={onError}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Setting;
